module.exports = __webpack_public_path__ + "static/img/apple.020e45c0.png";